<template>
  <v-row justify="center">
    <v-dialog scrollable max-width="400px" v-model="showDialog">
      <template v-slot:activator="{ on }">
        <v-btn color="info" small v-on="on">Anular</v-btn>
      </template>

      <v-card>
        <v-card-title>{{ titulo }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 100px;">
          <v-form v-model="validForm" ref="form">
            <v-text-field v-model="descripcion" :rules="[rules.required]" label="Descripcion"></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn> -->
          <v-btn color="blue darken-1" text @click="close">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="confirmar" :disabled="!validForm">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";


export default Vue.extend({
  props: ["titulo","id"],
  data() {
    return {
      showDialog: false,
      descripcion: '',
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres"
      },
      validForm: false
    };
  },
  methods: {
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    confirmar() {
      this.$emit("anulacionConfirmada", {id: this.id, descripcion: this.descripcion});
      this.$refs.form.reset();
      this.showDialog = false;
    }
  }
});
</script>